module.exports = __webpack_public_path__ + "img/speaker-Dudey.f03fba13.png";